export default class Foo{
    constructor() {
    }
    initialize(){

    }
}